export default class AdminLabProfiles {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminLabProfilesRoute}/${id}`, {})
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminLabProfilesRoute}/${id}`, payload, {})
  }
}
